import { Container } from "@mui/material";
import { Route, Routes } from "react-router";
import "./App.css";
import Blog from "./Components/Pages/Blog/Blog";
import Home from "./Components/Pages/Home/Home";
import Portfolio from "./Components/Pages/Portfolio/Portfolio";
import ProjectsDetails from "./Components/Pages/ProjectsDetails/ProjectsDetails";
import Footer from "./Components/Pages/Shared/Footer/Footer";

function App() {
  return (
    <div className="App">
      {/* <Header /> */}
      <Container>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/projects/:i" element={<ProjectsDetails />} />
        </Routes>
      </Container>
      {/* <hr /> */}
      <Footer />
    </div>
  );
}

export default App;
